<template>
  <resource-create-wrapper
    :title="item ? $t('resources.popups.duplicate_popup') : $t('resources.popups.new_popup')"
    :need-modal="showModal"
    :show-bottom-actions="true"
    @saveAction="$refs['popupForm'].submit()">
    <PopupForm :popup="item" @isDirtyForm="isDirtyForm" ref="popupForm"></PopupForm>
  </resource-create-wrapper>
</template>

<script>
  import ResourceCreateWrapper from "@/components/resourceWrappers/ResourceCreateWrapper";
  import PopupForm from "@/components/forms/PopupForm";
  import resourceCreateAndEditActions from "@/mixins/resourceCreateAndEditActions";

  export default {
    components: {
      ResourceCreateWrapper,
      PopupForm,
    },
    mixins: [resourceCreateAndEditActions],
    props: {
      id: {
        type: String,
        required: false,
      },
      title: {
        type: String,
        required: true,
      },
      /**
       * Item is provided here when duplicating
       */
      item: {
        type: Object,
        required: false,
        default() {
          return {};
        },
      },
    },
  };
</script>
